import { setMainPhone } from "./setMainPhone";

/**
 * 結算頁驗證卡「驗證哪支，那支就是帳號手機」的前端入口（2026-10-14 拍板）。
 * 後端規則：帳號手機未驗證過才可覆寫；已驗證過另一支回 updated=false 且帶回舊號碼——
 * 那不是成功，不可把舊號碼當成剛驗證的號碼顯示或填回表單。
 * 補登元件 CheckoutPhoneSetup（帳號沒手機）維持直接呼叫 setMainPhone，本次不改。
 */
export const VERIFIED_OTHER_MSG = "帳號手機已驗證過，無法更換成這支號碼";

export type SaveVerifiedPhoneResult =
  | { ok: true; phone: string }
  | { ok: false; kind: "verified_other" | "phone_taken" | "ticket_expired" | "unknown"; message: string };

const digits = (p: string) => (p || "").replace(/\D/g, "");

export async function saveVerifiedPhoneToAccount(args: {
  accessToken: string;
  phone: string;
  phoneVerifiedTicket: string;
}): Promise<SaveVerifiedPhoneResult> {
  const res = await setMainPhone(args);
  if (!res.ok) return { ok: false, kind: res.kind, message: res.message };
  if (!res.updated && digits(res.mainPhone) !== digits(args.phone)) {
    return { ok: false, kind: "verified_other", message: VERIFIED_OTHER_MSG };
  }
  return { ok: true, phone: digits(args.phone) };
}
